import { Form } from "reactstrap";
import CommonFileUpload from "../../../Common/CommonFileUpload";

const DropzoneClass = () => {
  return (
    <Form className="m-b-20">
      <CommonFileUpload />
    </Form>
  );
};

export default DropzoneClass;
